import CompositeCoursePage from './CompositeCoursePage'

export default CompositeCoursePage
